import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ActivityFilterForm from './ActivityFilterForm';

/**
 * Filter Bar displaying Filter and Reset Button
 * @version 1.0.1
 */
const ActivityFilterBar = ({ classes, title, ...rest }) => (
  <div className="bhp-filter-wrapper">
    {title && (
      <span className="ant-form ant-form-horizontal" style={{ width: '100%' }}>
        <legend>{title}</legend>
      </span>
    )}
    <div className={classNames(classes, 'bhp-filterbar')}>
      <ActivityFilterForm
        {...rest}
      />
    </div>
  </div>
);

ActivityFilterBar.propTypes = {
  activeText: PropTypes.string,
  classes: PropTypes.string,
  dataSource: PropTypes.object,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func,
  onResetClick: PropTypes.func,
  placeholder: PropTypes.string,
  themeName: PropTypes.string,
  reducerKey: PropTypes.string,
  title: PropTypes.string,
  showClearButton: PropTypes.bool,
  clearButtonText: PropTypes.string,
  maxTagCount: PropTypes.number,
  showActive: PropTypes.bool,
  showSearch: PropTypes.bool,
  showTags: PropTypes.bool,
  showToggle: PropTypes.bool
};

ActivityFilterBar.defaultProps = {
  activeText: '',
  classes: '',
  dataSource: {},
  onFieldsChange() {
  },
  onValuesChange() {
  },
  onResetClick() {
  },
  placeholder: '',
  themeName: '',
  reducerKey: '',
  title: 'Filter',
  showClearButton: true,
  clearButtonText: 'Clear',
  maxTagCount: 3,
  showActive: false,
  showSearch: true,
  showTags: true,
  showToggle: true
};

export default ActivityFilterBar;
